var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1645 25.0119L27.1635 25.0129L31.8681 29.7175C32.2606 30.11 32.3934 30.6728 32.2664 31.1804C32.394 30.6723 32.2614 30.1088 31.8684 29.7159L27.1645 25.0119ZM17.7247 30.4211C17.7897 30.1622 17.9224 29.9177 18.1226 29.7175L22.8272 25.0129L22.8266 25.0123L18.123 29.7159C17.9224 29.9165 17.7896 30.1616 17.7247 30.4211ZM31.8684 18.1386C32.2614 18.5316 32.394 19.0951 32.2664 19.6032C32.3934 19.0955 32.2606 18.5327 31.8681 18.1402C31.2749 17.547 30.2931 17.547 29.6999 18.1402L24.9953 22.8447L20.2908 18.1402C19.6976 17.547 18.7158 17.547 18.1226 18.1402C17.9222 18.3407 17.7894 18.5855 17.7245 18.8448C17.7893 18.5849 17.9221 18.3395 18.123 18.1386C18.7162 17.5455 19.698 17.5455 20.2912 18.1386L24.9957 22.8432L29.7003 18.1386C30.2935 17.5455 31.2753 17.5455 31.8684 18.1386ZM20.7155 32.3083L24.9957 28.0281L29.276 32.3083C29.7013 32.7336 30.2452 32.9341 30.7844 32.9341C31.3235 32.9341 31.8674 32.7336 32.2927 32.3083C33.1202 31.4808 33.1202 30.1191 32.2927 29.2916L28.0124 25.0114L32.2927 20.7311C33.1202 19.9036 33.1202 18.5419 32.2927 17.7144C31.4652 16.8869 30.1035 16.8869 29.276 17.7144L24.9957 21.9946L20.7155 17.7144C19.888 16.8869 18.5262 16.8869 17.6987 17.7144C16.8713 18.5419 16.8713 19.9036 17.6987 20.7311L21.979 25.0114L17.6987 29.2916C16.8713 30.1191 16.8713 31.4808 17.6987 32.3083C18.124 32.7336 18.6679 32.9341 19.2071 32.9341C19.7463 32.9341 20.2902 32.7336 20.7155 32.3083Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.004193c1f0c9cbe155b04b3b13a65b1a.svg";
export { ForwardRef as ReactComponent };